import React, { useEffect, useRef, useState } from "react";
import "./styles.scss";
import { useTheme } from "../../../../hook/useThemes";
import { activeEventFathom } from "../../../../utils/utils";

interface SelectHoursProps {
  onSelectHours: (value: any) => void;
}
export default function SelectHours(props: SelectHoursProps) {
  const { onSelectHours } = props;
  const { lang } = useTheme();
  const ListItem: any[] = [
    // {
    //   label: lang?.select || "Select a period…",
    //   value: 0,
    // },
    {
      label: lang?.last_hours || "Last hour",
      value: 1,
      key: "History-LastHour",
    },
    {
      label: lang?.last_day_select || "Last day",
      value: 24,
      key: "History-LastDay",
    },
    {
      label: lang?.last_month_select || "Last month",
      value: 30 * 24,
      key: "History-LastMonth",
    },
  ];

  const [hoursSelect, setHoursSelect] = useState<string>(ListItem[0].label);
  const [showListItem, setShowListItem] = useState<boolean>(false);
  const refContent = useRef<any>();

  const handleSelectHours = (item: any) => {
    setHoursSelect(item?.label || "");
    setShowListItem(false);
    onSelectHours(item?.value);
  };

  useEffect(() => {
    const handleClick = (ev: any) => {
      if (!refContent.current?.contains(ev.target) && ev) {
        setShowListItem(false);
      }
    };
    if (window) {
      window.addEventListener("click", handleClick);
    }
    return () => {
      window.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <div
      className="wrapper-select-hours"
      onClick={() => {
        !showListItem && setShowListItem(true);
      }}
      ref={refContent}
    >
      <p className="label-select-hours">{hoursSelect}</p>
      <svg
        width="10"
        height="5"
        viewBox="0 0 10 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 0L5 5L10 0H0Z" fill="#141C29" />
      </svg>

      <div
        className={`list-content-item ${
          showListItem && "show-list-content-item"
        }`}
      >
        {ListItem.map((item: any, index) => {
          return (
            <p
              className="item-hours"
              key={item?.value}
              onClick={() => {
                handleSelectHours(item);
                activeEventFathom(item.key);
              }}
            >
              {item?.label}
            </p>
          );
        })}
      </div>
    </div>
  );
}
